/** Maps i18next language codes to the document `lang` attribute (BCP 47). */
export function syncHtmlDocumentLanguage(language: string): void {
  if (typeof document === "undefined") return;
  document.documentElement.lang = language;
}
